
import type { Result } from '@empathyco/x-types'
import type { PropType } from 'vue'
import type Vue from 'vue'
import type { ExplainMessages } from '../../../models'
import { HalfDonutChartComponent } from '@empathyco/insights'
import { defineComponent, getCurrentInstance, onMounted, watch } from 'vue'
import { mapResultToHalfDonutChartData } from './map-result-to-half-donut-chart-data'

export default defineComponent({
  name: 'ScoresVisualization',
  props: {
    result: {
      type: Object as PropType<Result>,
      required: true,
    },
  },
  setup(props) {
    const instance = getCurrentInstance() as { proxy: Vue }
    const messages = instance.proxy.$epb.messages.explain as ExplainMessages
    const halfDonutChartComponent = new HalfDonutChartComponent()
    const halfDonutChartComponentConfig = {
      locale: 'en',
      transitionsDurationInMillis: 0,
    }

    function initHalfDonutChart(): void {
      const data = mapResultToHalfDonutChartData(props.result, messages)
      halfDonutChartComponent.init(instance.proxy.$el as HTMLElement, {
        config: halfDonutChartComponentConfig,
        data,
      })
    }

    function updateHalfDonutChart(): void {
      const data = mapResultToHalfDonutChartData(props.result, messages)
      return halfDonutChartComponent.update({
        config: halfDonutChartComponentConfig,
        data,
      })
    }

    watch(
      () => props.result,
      () => updateHalfDonutChart(),
    )

    onMounted(initHalfDonutChart)

    return {
      baseClass: 'epb-scores-visualization',
    }
  },
})
